import React from 'react';
import { waypointPropTypes } from '../../../../utils/prop-types';
import { Container } from './delivery-failed-body.styles';
import Address from '../../address';

const DeliveryFailedBody = ({ waypoint }) => {
  return (
    <Container>
      <Address type={waypoint.waypointType} location={waypoint.location} />
    </Container>
  );
};

DeliveryFailedBody.propTypes = {
  waypoint: waypointPropTypes.isRequired,
};

export default DeliveryFailedBody;



// WEBPACK FOOTER //
// ./src/app/order-card/delivery-failed/body/delivery-failed-body.js